type MobileAppFrameProps = {
  children: React.ReactNode;
};

export default function MobileAppFrame({ children }: MobileAppFrameProps) {
  return (
    <div className="mx-auto flex min-h-[100dvh] w-full max-w-md flex-col overflow-x-hidden bg-white">
      {children}
    </div>
  );
}
